// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M.531.028a.832.832 0 0 0-.46.4.806.806 0 0 0-.023.592c.052.14.189.28 5.468 5.562L10.932 12l-5.416 5.418C.236 22.701.1 22.84.048 22.98c-.223.607.366 1.192.977.97.134-.05.333-.245 5.557-5.466L12 13.068l5.418 5.416c5.224 5.22 5.423 5.417 5.557 5.465.374.137.799-.036.951-.386.03-.07.065-.146.077-.169.026-.051.028-.337.002-.321-.01.006-.038-.044-.062-.113-.04-.116-.407-.488-5.459-5.542L13.068 12l5.415-5.418c4.94-4.943 5.42-5.429 5.458-5.538a.754.754 0 0 1 .063-.143c.03-.033.025-.331-.004-.313-.013.008-.024-.002-.024-.023a.757.757 0 0 0-.996-.516c-.14.051-.28.188-5.562 5.467L12 10.932 6.582 5.516C1.358.296 1.159.1 1.025.051A.884.884 0 0 0 .531.028M.008.756c0 .092.004.127.01.077a.897.897 0 0 0 0-.168C.011.623.007.664.007.756m0 22.488c0 .092.004.127.01.077a.897.897 0 0 0 0-.168c-.006-.042-.01-.001-.01.091"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const CloseIcon = Icon;
export default CloseIcon;
